module.exports = __webpack_public_path__ + "static/img/interview-with-raph-mokades.65dd223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/interview-with-raph-mokades.png
// module id = V76G
// module chunks = 0